<template>
  <v-app>
    <AppWrapperView>
      <v-main>
        <v-container class="pa-8 print_none" fluid>
          <v-row v-if="hasPrintError">
            <v-col cols="12">
              <v-alert v-model="hasPrintError" type="error" density="compact" :title=printErrorMsg closable class="ma-2" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-text-field
                density="compact"
                variant="outlined"
                hide-details="auto"
                v-model="searchCondition.denpyouBangou"
                :label="$t('shukkaPre.label.denpyouBangou')"
              />
            </v-col>
            <v-col cols="3">
              <v-select
                density="compact"
                variant="outlined"
                hide-details="auto"
                v-model="searchCondition.shoriKubun"
                :label="$t('shukkaPre.label.shoriKubun')"
                :items="shoriKbnItem"
                item-title="label"
                item-value="key"
                clearable
                return-object
              />
            </v-col>
            <v-col cols="3">
              <v-select
                density="compact"
                variant="outlined"
                hide-details="auto"
                v-model="searchCondition.shukkamoto"
                :items="shukkamotoItem"
                item-title="code_name"
                item-value="code"
                :label="$t('shukkaPre.label.shukkamoto')"
                return-object
              />
            </v-col>
            <v-col cols="3">
              <v-select
                density="compact"
                variant="outlined"
                hide-details="auto"
                v-model="searchCondition.shukkasaki"
                :items="shukkasakiItem"
                item-title="code_name"
                item-value="code"
                :label="$t('shukkaPre.label.shukkasaki')"
                clearable
                return-object
              />
            </v-col>
            <v-col cols="3">
              <DatePicker
                ref="savedFrom"
                v-model="searchCondition.savedDateFrom"
                :label="$t('shukkaPre.label.savedDateFrom')"
              />
            </v-col>
            <v-col cols="3">
              <DatePicker
                ref="savedTo"
                v-model="searchCondition.savedDateTo"
                :label="$t('shukkaPre.label.savedDateTo')"
              />
            </v-col>
            <v-col cols="3">
              <DatePicker
                ref="shukkaFrom"
                v-model="searchCondition.shukkaDateFrom"
                :label="$t('shukkaPre.label.shukkaDateFrom')"
              />
            </v-col>
            <v-col cols="3">
              <DatePicker
                ref="shukkaTo"
                v-model="searchCondition.shukkaDateTo"
                :label="$t('shukkaPre.label.shukkaDateTo')"
              />
            </v-col>
            <v-col cols="12" class="text-right">
              <v-btn text @click="clear">{{ $t('common.action.clear') }}</v-btn>
              <v-btn
                class="ml-4 px-8 bg-grey-darken-3"
                theme="dark"
                elevation="2"
                @click="search"
                :loading="isSearching"
              >
                {{ $t('common.action.search') }}
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-table density="compact" class="text-no-wrap">
                <thead>
                  <tr>
                    <th
                      v-for="header in headers"
                      :key="header"
                      @click.stop="tableSort(header)"
                      style="cursor: pointer;"
                    >
                      {{ $t('shukkaPre.label.table.' + header) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in filteredDataList"
                    :key="item.preManagementId"
                    @click="rowClick(item)"
                    style="cursor: pointer;"
                  >
                    <td>{{ item.denpyoNumber }}</td>
                    <td>{{ item.syoriKubunLabel }}</td>
                    <td>{{ formatDateTime(item.savedDate) }}</td>
                    <td>{{ formatDateTime(item.shukkaDate) }}</td>
                    <td>{{ item.shukkamotoCode }}</td>
                    <td>{{ item.shukkamotoName }}</td>
                    <td>{{ item.shukkasakiCode }}</td>
                    <td>{{ item.shukkasakiName }}</td>
                    <td>{{ item.actualSuuryo }}</td>
                    <td>{{ item.status }}</td>
                    <td>
                      <v-btn
                        dark
                        class="px-8 bg-indigo-darken-1"
                        elevation="2"
                        @click.stop="printReport(item)"
                      >{{ $t('shukkaPre.label.printReport') }}</v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td :colspan="headers.length"></td>
                  </tr>
                </tbody>
              </v-table>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="3"></v-col>
            <v-col cols="6">
              <v-pagination v-model="currentPageNo" :length="maxPageNo" />
            </v-col>
            <v-col cols="3">
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="10" class="d-flex justify-end">
                  <v-select
                    density="compact"
                    variant="outlined"
                    hide-details="auto"
                    v-model="displayPerPage"
                    :items="displayPerPageItem"
                    item-title="name"
                    item-value="value"
                    :label="$t('common.label.displayCountPerPage')"
                    @update:modelValue="resetCondition"
                    return-object
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="text-right">
                  {{ displayContentNo.minNo }} - {{ displayContentNo.maxNo }}{{ $t('common.label.displayedDataRange') }} / {{ dataList.length }}{{ $t('common.label.totalCountOf') }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <ZeroData v-if="zeroDataWarningDialogFlg" :handle-ok="closeZeroDataDialog" />
          <MessageDialog v-if="commonMsgDlgVisible" :dialog-data="dialogData" :handle-ok="closeMessageDialog" />
        </v-container>
        <ShukkaPreDetailReport :print-data="printData" />
      </v-main>
    </AppWrapperView>
  </v-app>
</template>

<script lang="js">
import AppWrapperView from "@/components/views/AppWrapperView";
import DatePicker from "@/components/DatePicker";
import ZeroData from "@/components/dialog/ZeroDataDialog";
import MessageDialog from "@/components/dialog/MessageDialog";
import api from "@/apis/staff";
import store from "@/store";
import router from "@/router";
import Paths from "@/router/indexPaths";
import utils from "@/utils";
import ShukkaPreDetailReport from "@/components/report/ShukkaPreDetailReport"

const createSearchCondition = (defaultShop = null) => ({
  denpyouBangou: "",
  shoriKubun: "",
  shukkamoto: defaultShop,
  shukkasaki: null,
  savedDateFrom: "",
  savedDateTo: "",
  shukkaDateFrom: "",
  shukkaDateTo: "",
});

export default {
  components: { AppWrapperView, DatePicker, ZeroData, MessageDialog, ShukkaPreDetailReport },
  computed: {
    shoriKbnItem() {
      const shippedKbnList = store.getShippedKbnList();
      if (!shippedKbnList) return [];
      const list = [];
      for (const e of JSON.parse(shippedKbnList).filter(e => e.isAvailable)) {
        list.push({ label: this.$t("common.label.shippedKbn." + e.key), ...e });
      }
      return list;
    },
    displayContentNo() {
      const minNo = this.dataList.length !== 0 ? 1 + (this.displayPerPage.value * (this.currentPageNo - 1)) : 0;
      const maxNo = this.displayPerPage.value * this.currentPageNo;
      if (maxNo > this.dataList.length || this.displayPerPage.value === 0) {
        return { minNo: minNo, maxNo: this.dataList.length };
      }
      return { minNo: minNo, maxNo: maxNo };
    },
    maxPageNo() {
      if (this.displayPerPage.value === 0) return 0;
      return Math.ceil(this.dataList.length / this.displayPerPage.value);
    },
    sortedTable() {
      let tempArray = this.dataList.map(x => ({ ...x }));
      if (this.sortState.target !== "") {
        const target = this.sortState.target;
        const direction = this.sortState.ascent ? 1 : -1;
        tempArray = tempArray.sort((a, b) => {
          const left = a[target] ?? "";
          const right = b[target] ?? "";
          if (left > right) return direction;
          if (left < right) return direction * -1;
          return 0;
        });
      }
      return tempArray;
    },
    filteredDataList() {
      return this.sortedTable.slice(this.displayContentNo.minNo - 1, this.displayContentNo.maxNo);
    },
  },
  data: () => ({
    headers: [
      "denpyoNumber",
      "syoriKubunLabel",
      "savedDate",
      "shukkaDate",
      "shukkamotoCode",
      "shukkamotoName",
      "shukkasakiCode",
      "shukkasakiName",
      "actualSuuryo",
      "status",
      "print",
    ],
    currentPageNo: 1,
    displayPerPage: { name: "15", value: 15 },
    displayPerPageItem: [],
    sortState: { target: "", ascent: true },
    shukkamotoItem: [],
    shukkasakiItem: [],
    dataList: [],
    isSearching: false,
    zeroDataWarningDialogFlg: false,
    commonMsgDlgVisible: false,
    dialogData: { message: "", errorList: [] },
    searchCondition: createSearchCondition(),
    // 帳票データ
    printData: {},
    hasPrintError: false,
    printErrorMsg: "",
  }),
  methods: {
    /**
     * 出荷元・出荷先店舗の候補一覧の取得
     */
    async getValidShopSearchList() {
      const ownStoreRes = await api.post("/store/search", { selectSiteFlag: 1 });
      this.shukkamotoItem = (ownStoreRes.data.results?.shopList ?? []).map(element => ({
        name: element.name,
        code: element.code,
        code_name: element.code + "_" + element.name,
      }));

      const allStoreRes = await api.post("/store/search", { selectSiteFlag: 0 });
      this.shukkasakiItem = (allStoreRes.data.results?.shopList ?? []).map(element => ({
        name: element.name,
        code: element.code,
        code_name: element.code + "_" + element.name,
      }));
    },
    /**
     * ページングとソート状態の初期化
     */
    resetCondition() {
      this.currentPageNo = 1;
      this.sortState.target = "";
      this.sortState.ascent = true;
    },
    /**
     * 指定列による一覧テーブルのソート
     * @param {string} header ソート対象の列名
     */
    tableSort(header) {
      this.currentPageNo = 1;
      if (this.sortState.target === header) {
        this.sortState.ascent = !this.sortState.ascent;
      } else {
        this.sortState.target = header;
        this.sortState.ascent = true;
      }
    },
    /**
     * 日時文字列の画面表示用形式への変換
     * @param {string} value 表示対象の日時文字列
     * @returns {string} 整形後の日時
     */
    formatDateTime(value) {
      return utils.putSplitWordToCalendarWithTime(value);
    },
    /**
     * 0件ダイアログのクローズ
     */
    closeZeroDataDialog() {
      this.zeroDataWarningDialogFlg = false;
    },
    /**
     * メッセージダイアログのクローズ
     */
    closeMessageDialog() {
      this.commonMsgDlgVisible = false;
    },
    /**
     * メッセージダイアログへの内容設定と表示
     * @param {string} message 表示メッセージ
     * @param {Array} errorList エラー詳細一覧
     */
    showMessage(message, errorList = []) {
      this.dialogData = { message, errorList };
      this.commonMsgDlgVisible = true;
    },
    /**
     * 検索条件入力欄の初期化
     */
    clear() {
      this.$refs.savedFrom.clear();
      this.$refs.savedTo.clear();
      this.$refs.shukkaFrom.clear();
      this.$refs.shukkaTo.clear();
      this.searchCondition = createSearchCondition(this.shukkamotoItem[0] ?? null);
    },
    /**
     * API送信用検索条件オブジェクトの組み立て
     * @returns {object} 確定前出荷検索API用のリクエスト
     */
    createSearchPayload() {
      return {
        denpyoNumber: this.searchCondition.denpyouBangou,
        syoriKubun: this.searchCondition.shoriKubun?.key ?? "",
        shukkamotoCode: this.searchCondition.shukkamoto?.code ?? "",
        shukkasakiCode: this.searchCondition.shukkasaki?.code ?? "",
        savedDateFrom: this.searchCondition.savedDateFrom?.replaceAll("-", "") ?? "",
        savedDateTo: this.searchCondition.savedDateTo?.replaceAll("-", "") ?? "",
        shukkaDateFrom: this.searchCondition.shukkaDateFrom?.replaceAll("-", "") ?? "",
        shukkaDateTo: this.searchCondition.shukkaDateTo?.replaceAll("-", "") ?? "",
      };
    },
    /**
     * 確定前出荷一覧の検索と結果反映
     */
    search() {
      this.isSearching = true;
      store.setShukkaPreSearchCondition(JSON.stringify(this.searchCondition));
      api.post("/shukka/pre/search", this.createSearchPayload())
        .then((response) => {
          this.dataList = response.data.results?.shukkaList ?? [];
          this.resetCondition();
          if (this.dataList.length === 0) this.zeroDataWarningDialogFlg = true;
          this.isSearching = false;
        })
        .catch((error) => {
          this.isSearching = false;
          this.dataList = [];
          this.showMessage(
            error?.response?.data?.errorMessage ?? this.$t("common.message.errorAndRetry"),
            error?.response?.data?.errorList ?? []
          );
        });
    },
    /**
     * 選択した伝票の詳細画面への遷移
     * @param {object} item 一覧の選択行
     */
    rowClick(item) {
      store.setShukkaPreManagementId(String(item.preManagementId));
      router.push({ name: Paths.SHUKKA_PRE_DETAIL });
    },
    /**
     * セッションに保存された検索条件の復元と入力欄への反映
     */
    restoreSearchCondition() {
      const saved = store.getShukkaPreSearchCondition();
      if (!saved) {
        this.searchCondition = createSearchCondition(this.shukkamotoItem[0] ?? null);
        return;
      }

      const restoredCondition = JSON.parse(saved);
      this.searchCondition = {
        ...createSearchCondition(this.shukkamotoItem[0] ?? null),
        ...restoredCondition,
      };

      if (restoredCondition.shukkamoto?.code) {
        this.searchCondition.shukkamoto = this.shukkamotoItem.find(e => e.code === restoredCondition.shukkamoto.code)
          ?? restoredCondition.shukkamoto;
      }
      if (restoredCondition.shukkasaki?.code) {
        this.searchCondition.shukkasaki = this.shukkasakiItem.find(e => e.code === restoredCondition.shukkasaki.code)
          ?? restoredCondition.shukkasaki;
      }

      if (this.searchCondition.savedDateFrom) this.$refs.savedFrom.setDate(new Date(this.searchCondition.savedDateFrom));
      if (this.searchCondition.savedDateTo) this.$refs.savedTo.setDate(new Date(this.searchCondition.savedDateTo));
      if (this.searchCondition.shukkaDateFrom) this.$refs.shukkaFrom.setDate(new Date(this.searchCondition.shukkaDateFrom));
      if (this.searchCondition.shukkaDateTo) this.$refs.shukkaTo.setDate(new Date(this.searchCondition.shukkaDateTo));
    },
    /**
     * 帳票出力
     * @param data 選択した行データ
     */
    async printReport(data) {

      this.isSearching = true;
      this.hasPrintError = false;

      await api.post("/shukka/pre/report-data/search", {
        managementId: data.preManagementId,
      })
        .then((response) => {
          if(response.data?.status != 0) {
            this.hasPrintError = true;
            this.printErrorMsg = response.data.errorMessage;
            return;
          }
          if (response.data.results) {
            this.printData = response.data.results;
            this.$nextTick(() => {
              window.print();
            });
          } else {
            // 該当のデータが無い
            this.zeroDataWarningDialogFlg = true;
          }
        })
        .catch((error) => {
          this.hasPrintError = true;
          this.printErrorMsg = this.$t('common.message.unknownError');
        })
        .finally(() => {
          this.isSearching = false;
        });
    }
  },
  async mounted() {
    this.displayPerPage = utils.getDisplayPerPage(this.$t);
    this.displayPerPageItem = utils.getDisplayPerPageItem(this.$t);
    try {
      await this.getValidShopSearchList();
      this.restoreSearchCondition();
    } catch (error) {
      this.showMessage(
        error?.response?.data?.errorMessage ?? this.$t("common.message.errorAndRetry"),
        error?.response?.data?.errorList ?? []
      );
    }
  }
}
</script>
<style scoped>
@media print {
  .print_none {
    display: none;
  }
}
</style>
